import swal from "sweetalert";
import { InitPage } from "../index";

class BulkRePrint {
  init() {
    // Handle the Bulk Re-Print button click to check selection
    $(document).on("click", ".bulk-re-print-trigger", (e) => {
      e.preventDefault();

      const selectedItems = $(".handheld:checked"); // Check for selected tags

      // If no tags are selected, show an error message
      if (selectedItems.length === 0) {
        swal({
          title: "No tags selected",
          text: "Please select at least one tag to proceed.",
          icon: "error",
          buttons: ["Ok"],
        });
        return;
      }

      $("#bulk-re-print-message").text(`This action will reprint ${selectedItems.length} selected tag(s). Click on Re-Print to continue.`);

      // If tags are selected, open the modal
      $("#bulk-reprint-modal").modal("show");
    });

    // Handle the form submission inside the modal
    $(document).on("click", "#bulk-re-print-button", (e) => {
      e.preventDefault();

      const ids = this.getSelectedTags();

      // Add selected IDs to the hidden input field
      $("#selected_epcs").val(JSON.stringify(ids));

      const form = $("#bulk-re-print-form");

      $.ajax({
        type: "POST",
        url: form.attr("action"),
        data: form.serialize(),
        success: (_) => {
          // Close the modal before showing the SweetAlert success message
          $("#bulk-reprint-modal").modal("hide");

          // Uncheck all selected checkboxes (tags)
          $(".handheld:checked").prop("checked", false);

          // Wait for the modal to fully close before showing the alert
          setTimeout(() => {
            swal({
              title: "Success!",
              text: "Your selected tags have been scheduled for reprinting.",
              icon: "success",
              buttons: ["Ok"]
            });
          }, 500); // Small delay to allow modal to close smoothly
        },
        error: (xhr, status, error) => {
          const errorMessages = xhr.responseJSON
            ? xhr.responseJSON.message
            : { "There was an error processing your request. Please contact support for assistance.": [] };

          // Ensure errorMessages is an object
          const errorMessagesObject = typeof errorMessages === "object" ? errorMessages : { "Unknown error": [] };

          // Create a div element to hold all messages
          const errorContainer = document.createElement("div");

          // Iterate through each main error message
          Object.entries(errorMessagesObject).forEach(([mainMessage, assets]) => {
            // Add the main error message as a paragraph
            const paragraph = document.createElement("p");
            paragraph.innerText = mainMessage;
            errorContainer.appendChild(paragraph);

            // If there are asset details, display them as clickable links
            if (Array.isArray(assets) && assets.length > 0) {
              assets.forEach((asset, index) => {
                if (typeof asset === "object" && asset.url && asset.asset_id) {
                  const anchor = document.createElement("a");
                  anchor.innerText = asset.asset_id;
                  anchor.href = asset.url;
                  anchor.target = "_blank";
                  anchor.style.marginRight = "5px";
                  errorContainer.appendChild(anchor);

                  if (index < assets.length - 1) {
                    errorContainer.appendChild(document.createTextNode(", "));
                  }
                }
              });
            }
          });

          // Close the modal before showing the error message
          $("#bulk-reprint-modal").modal("hide");

          setTimeout(() => {
            swal({
              title: "Error!",
              content: {
                element: errorContainer
              },
              icon: "error",
              buttons: ["Ok"]
            });
          }, 500);
        }
      });
    });
  }

  getSelectedTags() {
    const selectedItems = $(".handheld:checked");
    return selectedItems.map((_, item) => $(item).val()).toArray();
  }
}

export function LoadPage() {
  InitPage("epc_tags", () => {
    const object = new BulkRePrint();
    object.init();
  });
}
